// extracted by mini-css-extract-plugin
export default {"altLoginLink":"gmTfqC","link":"BzOVLK"};